import request from './http'
const baseUrl = '/apass-base'
const publicUrl = '/mopower-public'
const businessUrl = '/apass-business'
export const addOutForm = (data: any) =>
  request({
    url: businessUrl + '/api/outform/record/insert',
    method: 'post',
    type: 'outForm',
    data
  })
export const wxApi = (data) =>
  request({
    url: data,
    method: 'get'
  })
export const getOutFormConfig = (data: any) =>
  request({
    url: businessUrl + '/api/outform/getConfig',
    method: 'post',
    type: 'outForm',
    data
  })
export const login = (data: any) =>
  request({
    url: baseUrl + '/api/user/login',
    method: 'post',
    data
  })
export const getUserInfo = () =>
  request({
    url: baseUrl + '/api/user/userCenter',
    method: 'get'
  })
export const initialize = (data: any) =>
  request({
    url: baseUrl + '/api/company/initialize',
    method: 'post',
    data
  })
export const getCode = (data: any) =>
  request({
    url: baseUrl + '/api/verification/reset/' + data.param,
    method: 'get'
  })
export const resetPwd = (data: any) =>
  request({
    url: baseUrl + '/api/user/resetPassword',
    method: 'post',
    data
  })
export const getegisterCode = (data: any) =>
  request({
    url: baseUrl + '/api/verification/register/' + data.param,
    method: 'get'
  })
export const register = (data: any) =>
  request({
    url: baseUrl + '/api/user/register',
    method: 'post',
    data
  })
// 第三方登陆  
export const loginByExternal = ({externalType, code, state}) =>
  request({
    url: publicUrl + `/external/login/${externalType}`,
    method: 'get',
    params: {code, state}
  })
// token登录  
export const loginByToken = (data: any) =>
  request({
    url: baseUrl + '/api/user/login/jwt',
    method: 'post',
    data
  })
